export const demoProducts = {
  eppProducts: [
    {
      id: 9999,
      customerId: 0,
      active: true,
      saison: {
        end: {
          day: 31,
          month: 12,
        },
        start: {
          day: 1,
          month: 1,
        },
      },
      contractExpiryDtg: null,
      contractId: 20192185,
      contractPosition: 230,
      contractStartDtg: '20191130',
      deadlines: ['08:00:00', '12:00:00'],
      language: null,
      parameter_sets: ['summer', 'winter'],
      resolutions: [
        {
          days: 2,
          hourly: 1,
        },
        {
          days: 4,
          hourly: 3,
        },
        {
          days: 15,
          hourly: 12,
        },
      ],
      stations: [
        {
          stationId: 10961,
          overwriteStationName: 'Zugspitze',
        },
        {
          stationId: 10384,
          overwriteStationName: 'Berlin-Tempelhof',
        },
        {
          stationId: 10385,
          overwriteStationName: 'Berlin-Schönefeld',
        },
        {
          stationId: 10637,
          overwriteStationName: 'Frankfurt/Main',
        },
        {
          stationId: 10739,
          overwriteStationName: 'Stuttgart',
        },
        {
          stationId: 10865,
          overwriteStationName: 'München',
        },
        {
          stationId: 10147,
          overwriteStationName: 'Hamburg',
        },
        {
          stationId: 10400,
          overwriteStationName: 'Düsseldorf',
        },
        {
          stationId: 10338,
          overwriteStationName: 'Hannover',
        },
        {
          stationId: 10469,
          overwriteStationName: 'Leipzig',
        },
        {
          stationId: 10513,
          overwriteStationName: 'Köln-Bonn',
        },
      ],
    },
  ],
  egpSummerProducts: [
    {
      active: true,
      areaId: 375,
      classType: 'EGPSUMMERProduct',
      contractExpiryDtg: null,
      contractId: 20192030,
      contractPosition: 20,
      contractStartDtg: '20190416',
      deadlines: ['08:00'],
      egpType: 'FOUR_DAY',
      id: 10011,
      language: 'de',
      parameters: [
        'TTT',
        'Td',
        'Neff3',
        'TRoad3',
        'RoadCondition3',
        'RR3',
        'wwP3',
        'ww3',
        'DD',
        'FF',
        'FX3',
        'Tb1',
        'Tb2',
        'Tb3',
        'Tb4',
        'Tb5',
      ],
      saison: {
        end: {
          day: '31',
          month: '10',
        },
        start: {
          day: '19',
          month: '04',
        },
      },
    },
  ],
  egwProducts: [
    {
      active: true,
      areaId: 46,
      classType: 'EGWProduct',
      contractExpiryDtg: null,
      contractId: 201820132,
      contractPosition: 40,
      contractStartDtg: '20180703',
      id: 4239,
      longText: false,
      saison: {
        end: {
          day: '31',
          month: '12',
        },
        start: {
          day: '01',
          month: '01',
        },
      },
    },
  ],
  egwSummerProducts: [
    {
      active: true,
      classType: 'EGWSUMMERProduct',
      contractExpiryDtg: null,
      contractId: 201820132,
      contractPosition: 250,
      contractStartDtg: '20201106',
      heavyRainWarning: true,
      id: 4281,
      info: true,
      nowcast: true,
      points: [
        {
          latitude: 47.421215,
          longitude: 10.986297,
          searchName: 'Zugspitze',
        },
      ],
      precipitationWarning: true,
      saison: {
        end: {
          day: '31',
          month: '12',
        },
        start: {
          day: '01',
          month: '01',
        },
      },
      windWarning: true,
    },
  ],
  marwisProducts: [
    {
      active: true,
      classType: 'MarwisProduct',
      contractExpiryDtg: null,
      contractId: 201820132,
      contractPosition: 100,
      contractStartDtg: '20180701',
      id: 1846,
      saison: {
        end: {
          day: '31',
          month: '12',
        },
        start: {
          day: '01',
          month: '01',
        },
      },
      vehicles: [
        {
          id: '101117',
          name: 'Fahrzeug 2',
        },
        {
          id: '1000',
          name: 'Waiblingen',
        },
      ],
    },
  ],
  radarProducts: [
    {
      active: true,
      classType: 'RadarProduct',
      contractExpiryDtg: null,
      contractId: 201820132,
      contractPosition: 50,
      contractStartDtg: '20191130',
      id: 1754,
      points: [
        {
          latitude: 52.5170365,
          longitude: 13.3888599,
          searchName: 'Berlin',
        },
        {
          latitude: 48.1371079,
          longitude: 11.5753822,
          searchName: 'München',
        },
        {
          latitude: 50.938361,
          longitude: 6.959974,
          searchName: 'Köln',
        },
        {
          latitude: 51.4825041,
          longitude: 11.9705452,
          searchName: 'Halle (Saale)',
        },
      ],
      region: 'de',
      saison: {
        end: {
          day: '31',
          month: '12',
        },
        start: {
          day: '01',
          month: '01',
        },
      },
    },
    {
      id: 3441,
      active: true,
      points: [
        {
          latitude: 52.3727598,
          longitude: 4.8936041,
          searchName: 'Amsterdam',
        },
      ],
      region: 'benelux',
      saison: {
        end: {
          day: '31',
          month: '03',
        },
        start: {
          day: '01',
          month: '08',
        },
      },
      classType: 'RadarProduct',
      contractId: 201820132,
      contractPosition: 160,
      contractStartDtg: '20181121',
      contractExpiryDtg: null,
    },
  ],
  satelliteProducts: [
    {
      id: 8888,
      active: true,
      classType: 'SatelliteProduct',
      contractStartDtg: '20191130',
      contractExpiryDtg: null,
      contractId: 999999999,
      contractPosition: 50,
      saison: {
        end: {
          day: '31',
          month: '12',
        },
        start: {
          day: '01',
          month: '01',
        },
      },
      region: 'eu',
      types: ['eu-ir108-15min', 'eu-hrv-15min'],
      points: [
        {
          searchName: 'france',
          latitude: 52.37276,
          longitude: 4.8936043,
        },
      ],
    },
  ],
  modelProducts: [
    {
      id: 7777,
      active: true,
      classType: 'ModelProduct',
      contractStartDtg: '20191130',
      contractExpiryDtg: null,
      contractId: 999999999,
      contractPosition: 50,
      saison: {
        end: {
          day: '31',
          month: '12',
        },
        start: {
          day: '01',
          month: '01',
        },
      },
      modelDetails: [
        {
          model: 'ecmwf',
          parameters: ['TMP2m', 'PRCUM', 'Wind', 'SF'],
        },
        {
          model: 'gfs',
          parameters: ['TMP2m', 'PRCUM', 'Wind'],
        },
      ],
      points: [
        {
          searchName: 'Europe',
          latitude: 48.491853,
          longitude: 5.328939,
          zoom: 3,
        },
        {
          searchName: 'Spain',
          latitude: 40.626098,
          longitude: -4.613202,
          zoom: 5,
        },
      ],
    },
  ],
  smwProducts: [
    {
      active: true,
      archive: null,
      classType: 'SMWProduct',
      contractExpiryDtg: null,
      contractId: 201820132,
      contractPosition: 150,
      contractStartDtg: '20190326',
      id: 2966,
      saison: {
        end: {
          day: '31',
          month: '12',
        },
        start: {
          day: '01',
          month: '01',
        },
      },
      stations: [
        {
          overwriteStationName: 'Greifswald',
          stationId: '10184',
          stationSource: 'dwd',
          stationType: 'synop',
        },
        {
          overwriteStationName: 'Berlin-Tempelhof',
          stationId: '10384',
          stationSource: 'dwd',
          stationType: 'synop',
        },
        {
          overwriteStationName: 'Nuernberg',
          stationId: '10763',
          stationSource: 'dwd',
          stationType: 'synop',
        },
        {
          overwriteStationName: 'Köhlbrandbrücke West',
          stationId: '100471',
          stationSource: 'lufft',
          stationType: 'gma',
        },
        {
          overwriteStationName: 'Am Botterbarg',
          stationId: '100465',
          stationSource: 'lufft',
          stationType: 'gma',
        },
        {
          overwriteStationName: 'Schiffbeker Weg',
          stationId: '100469',
          stationSource: 'lufft',
          stationType: 'gma',
        },
        {
          overwriteStationName: 'Alte Schmiede',
          stationId: '100472',
          stationSource: 'lufft',
          stationType: 'gma',
        },
        {
          overwriteStationName: 'Köhlbrandbrücke Ost',
          stationId: '100468',
          stationSource: 'lufft',
          stationType: 'gma',
        },
        {
          overwriteStationName: 'Reutlingen-Kalkstraessle',
          stationId: '104961',
          stationSource: 'lufft',
          stationType: 'gma',
        },
        {
          overwriteStationName: 'DL031-Esslingen-Jaegerhaus',
          stationId: '104951',
          stationSource: 'lufft',
          stationType: 'gma',
        },
        {
          overwriteStationName: 'Waiblingen-MK703-Bittenfeld',
          stationId: '101776',
          stationSource: 'lufft',
          stationType: 'gma',
        },
        {
          overwriteStationName: 'Weilheim',
          stationId: '104655',
          stationSource: 'lufft',
          stationType: 'gma',
        },
        {
          overwriteStationName: 'Kaufbeuren',
          stationId: '101770',
          stationSource: 'lufft',
          stationType: 'gma',
        },
        {
          overwriteStationName: 'Zugspitze',
          stationId: '10961',
          stationSource: 'dwd',
          stationType: 'synop',
        },
      ],
    },
  ],
  routeProducts: [
    {
      id: 10429,
      active: true,
      routes: [],
      saison: {
        end: {
          day: '31',
          month: '03',
        },
        start: {
          day: '01',
          month: '11',
        },
      },
      stations: [
        {
          stationId: '104617',
          stationType: 'gma',
          stationSource: 'lufft',
          overwriteStationName: 'Freiburg-Westrandstadt',
        },
      ],
      classType: 'RouteProduct',
      contractId: 202120061,
      streetTypes: [
        'primary',
        'secondary',
        'tertiary',
        'motorway',
        'residential',
        'trunk',
        'unclassified',
      ],
      zoomRegions: {
        roads: [
          {
            id: 101,
            name: 'Freiburg im Breisgau',
            mapCenter: {
              latitude: 47.9960901,
              longitude: 7.8494005,
            },
            zoomLevel: 13,
            northEastBBoxCoordinate: {
              latitude: 48.042053700358586,
              longitude: 7.918052673339845,
            },
            southWestBBoxCoordinate: {
              latitude: 47.9501556913891,
              longitude: 7.780723571777345,
            },
          },
        ],
        widely: [
          {
            id: 10,
            name: 'Deutschland',
            mapCenter: {
              latitude: 51.505,
              longitude: 10.09,
            },
            zoomLevel: 6,
            northEastBBoxCoordinate: {
              latitude: 56.65622649350222,
              longitude: 18.874511718750004,
            },
            southWestBBoxCoordinate: {
              latitude: 45.706179285330855,
              longitude: 1.2963867187500002,
            },
          },
        ],
      },
      streetParameter: ['rst', 'rsc'],
      contractPosition: 80,
      contractStartDtg: '20211101',
      contractExpiryDtg: '20260430',
    },
    {
      id: 3976,
      active: true,
      routes: [],
      saison: {
        end: {
          day: '15',
          month: '04',
        },
        start: {
          day: '01',
          month: '11',
        },
      },
      stations: [
        {
          stationId: '104587',
          stationType: 'virt',
          stationSource: 'virt',
          overwriteStationName: 'Chemnitz',
        },
        {
          stationId: '101249',
          stationType: 'gma',
          stationSource: 'dwd',
          overwriteStationName: 'Gloesa',
        },
        {
          stationId: '104589',
          stationType: 'gma',
          stationSource: 'lufft',
          overwriteStationName: 'Chemnitz-S236',
        },
        {
          stationId: '10577',
          stationType: 'synop',
          stationSource: 'dwd',
          overwriteStationName: 'Chemnitz',
        },
      ],
      classType: 'RouteProduct',
      contractId: 201820277,
      streetTypes: [
        'primary',
        'secondary',
        'tertiary',
        'motorway',
        'residential',
        'trunk',
        'unclassified',
      ],
      zoomRegions: {
        roads: [
          {
            id: 101,
            name: 'Chemnitz',
            mapCenter: {
              latitude: 50.83226079999998,
              longitude: 12.925297699999994,
            },
            zoomLevel: 13,
            northEastBBoxCoordinate: {
              latitude: 50.95,
              longitude: 13,
            },
            southWestBBoxCoordinate: {
              latitude: 50.74,
              longitude: 12.84,
            },
          },
        ],
        widely: [
          {
            id: 10,
            name: 'Deutschland',
            mapCenter: {
              latitude: 51.505,
              longitude: 10.09,
            },
            zoomLevel: 6,
            northEastBBoxCoordinate: {
              latitude: 56.65622649350222,
              longitude: 18.874511718750004,
            },
            southWestBBoxCoordinate: {
              latitude: 45.706179285330855,
              longitude: 1.2963867187500002,
            },
          },
          {
            id: 11,
            name: 'Chemnitz',
            mapCenter: {
              latitude: 50.83226079999998,
              longitude: 12.925297699999994,
            },
            zoomLevel: 8,
            northEastBBoxCoordinate: {
              latitude: 50.95,
              longitude: 13,
            },
            southWestBBoxCoordinate: {
              latitude: 50.74,
              longitude: 12.84,
            },
          },
        ],
      },
      streetParameter: ['rst', 'rsc'],
      contractPosition: 90,
      contractStartDtg: '20171101',
      contractExpiryDtg: null,
    },
  ],
  egwGmaProducts: [
    {
      active: true,
      classType: 'EGWGMAProduct',
      contractExpiryDtg: null,
      contractId: 201820132,
      contractPosition: 130,
      contractStartDtg: '20191001',
      id: 3685,
      language: 'de',
      saison: {
        end: {
          day: '30',
          month: '04',
        },
        start: {
          day: '01',
          month: '08',
        },
      },
      stations: [
        {
          overwriteStationName: 'DL031-Esslingen-Jaegerhaus',
          stationId: '104951',
          stationSource: 'lufft',
          stationType: 'gma',
        },
      ],
    },
  ],
  egpProducts: [
    {
      active: true,
      areaId: 46,
      classType: 'EGPProduct',
      contractExpiryDtg: '20210331',
      contractId: 201820132,
      contractPosition: 170,
      contractStartDtg: '20201028',
      deadlines: ['08:00'],
      egpType: 'TWO_DAY',
      id: 4237,
      language: 'de',
      parameters: [
        'SYMBOL',
        'TTT',
        'Td',
        'TRoad',
        'RoadCondition',
        'TBridge',
        'BridgeCondition',
        'TFoot',
        'FootCondition',
        'TBike',
        'BikeCondition',
        'RR1',
        'ww',
        'wwP',
        'relRRS1',
        'wwS',
        'HSdLq',
        'DD',
        'FF',
        'FX1',
        'Neff',
        'Tb1',
        'Tb2',
        'Tb3',
        'Tb4',
        'Tb5',
      ],
      saison: {
        end: {
          day: '31',
          month: '03',
        },
        start: {
          day: '07',
          month: '12',
        },
      },
    },
  ],
  trafficLightsProducts: [
    {
      active: true,
      classType: 'TrafficLightsProduct',
      contractExpiryDtg: null,
      contractId: 201820132,
      contractPosition: 220,
      contractStartDtg: '20180701',
      id: 1845,
      saison: {
        end: {
          day: '30',
          month: '04',
        },
        start: {
          day: '15',
          month: '07',
        },
      },
    },
  ],
  pigeonProducts: [
    {
      id: 8888,
      active: true,
      saison: {
        end: {
          day: '31',
          month: '12',
        },
        start: {
          day: '01',
          month: '01',
        },
      },
      classType: 'PigeonProduct',
      contractId: 20192075,
      contractPosition: 140,
      contractStartDtg: '20200116',
      contractExpiryDtg: null,
      routes: [
        {
          id: 'route1',
          name: 'R01 Ruffec - Nordhausen',
          stations: {
            start: 7420,
            end: 104863,
          },
        },
        {
          id: 'route2',
          name: 'R02 Vivonne - Mönchengladbach',
          stations: {
            start: 7330,
            end: 105765,
          },
        },
        {
          id: 'route3',
          name: 'R03 Antwerpen - Warschau',
          stations: {
            start: 6450,
            end: 12375,
          },
        },
        {
          id: 'route4',
          name: 'R04b Wien - Kleve',
          stations: {
            start: 11034,
            end: 103547,
          },
        },
        {
          id: 'route5',
          name: 'R05 Chalon-sur-Saône - Oldenburg',
          stations: {
            start: 104308,
            end: 10215,
          },
        },
        {
          id: 'route6',
          name: 'R06 Warschau - Heide',
          stations: {
            start: 12375,
            end: 100378,
          },
        },
        {
          id: 'route7',
          name: 'R07 Canapeville - Bayreuth',
          stations: {
            start: 7038,
            end: 10677,
          },
        },
        {
          id: 'route8',
          name: 'R08 Brüssel - München',
          stations: {
            start: 6416,
            end: 101556,
          },
        },
        {
          id: 'route9',
          name: 'R09 Heidenheim - Flensburg',
          stations: {
            start: 104727,
            end: 100355,
          },
        },
        {
          id: 'route10',
          name: 'R10 Antwerpen - Görlitz',
          stations: {
            start: 6450,
            end: 10499,
          },
        },
        {
          id: 'route11',
          name: 'R11 Angoulême - Memmingen',
          stations: {
            start: 7420,
            end: 101595,
          },
        },
        {
          id: 'route12',
          name: 'R12 Paderborn - Gien',
          stations: {
            start: 10430,
            end: 7257,
          },
        },
        {
          id: 'route13',
          name: 'R13 Würzburg - Brive',
          stations: {
            start: 101333,
            end: 7412,
          },
        },
        {
          id: 'route14',
          name: 'R14 Bremen - Weil am Rhein',
          stations: {
            start: 100522,
            end: 101759,
          },
        },
        {
          id: 'route15',
          name: 'R15 Knokke - Neumarkt/Nürnberg',
          stations: {
            start: 6308,
            end: 101375,
          },
        },
        {
          id: 'route16',
          name: 'R04a Wien - Emmen',
          stations: {
            start: 11034,
            end: 100106,
          },
        },
        {
          id: 'route25',
          name: 'R17 Bouillon - Passau',
          stations: {
            start: 6467,
            end: 103993,
          },
        },
        {
          id: 'route26',
          name: 'R18 Warschau - Frankfurt/Main',
          stations: {
            start: 12375,
            end: 103734,
          },
        },
        {
          id: 'route27',
          name: 'R19 Groningen - Aue',
          stations: {
            start: 100182,
            end: 103869,
          },
        },
        {
          id: 'route28',
          name: 'R20 Andrezel - Dresden',
          stations: {
            start: 104288,
            end: 10488,
          },
        },
        {
          id: 'route29',
          name: 'R21 Roosendaal - Anklam',
          stations: {
            start: 100293,
            end: 103366,
          },
        },
        {
          id: 'route30',
          name: 'R22 Chimay - Salzburg',
          stations: {
            start: 6455,
            end: 11150,
          },
        },
        {
          id: 'route31',
          name: 'R23 Wien - Freiburg',
          stations: {
            start: 11034,
            end: 104617,
          },
        },
        {
          id: 'route32',
          name: 'R24 Le Mans – Zürich',
          stations: {
            start: 7235,
            end: 6660,
          },
        },
        {
          id: 'route33',
          name: 'R25 Prag - Freiburg',
          stations: {
            start: 11518,
            end: 6628,
          },
        },
        {
          id: 'route34',
          name: 'R26 Baden-Baden – Frederikshavn',
          stations: {
            start: 105041,
            end: 6034,
          },
        },
        {
          id: 'route35',
          name: 'R27 München - Frederikshavn',
          stations: {
            start: 101628,
            end: 6034,
          },
        },
        {
          id: 'route36',
          name: 'R28 Poznan - Frankfurt/Main',
          stations: {
            start: 12330,
            end: 103734,
          },
        },
      ],
    },
  ],
};
